import { render, staticRenderFns } from "./ticketdetails.vue?vue&type=template&id=079d1497"
import script from "./ticketdetails.vue?vue&type=script&lang=js"
export * from "./ticketdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports